/**
 * FeedbackCompletionResultDisplay
 */
export enum FeedbackCompletionResultDisplay {
    STATUS_ONLY = 'status_only',
    SCORE = 'score',
    PERCENTAGE = 'percentage'
}
